import { Button, Card, Chip, Divider, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { SmsCampaignDto } from "../../../api/psc";
import { CardInformation } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { toJalaliDate } from "../../../utils/date";
import { ParseSmsCampaignStatus } from "../constants/SmsCampaignContants";
import SmsCampaignRecordDialog from "../dialogs/SmsCampaignRecordDialog";

// updated
export default function SmsCampaignItem(props: {
    smsCampaign: SmsCampaignDto;
}) {
    const smsCampaign = props.smsCampaign;

    const { openDialog } = useContext(DialogContext);

    const smsCampaignStatus = ParseSmsCampaignStatus(smsCampaign.status);

    const openRecordsDialog = () => {
        openDialog(<SmsCampaignRecordDialog smsCampaign={smsCampaign} />);
    };

    return (
        <Card>
            <Stack sx={{ p: 2 }} spacing={1.5}>
                <Typography>{smsCampaign.template}</Typography>

                <Divider />

                <Stack spacing={1}>
                    <CardInformation
                        title="سرشماره"
                        value={smsCampaign.gatewayNumber}
                    />
                    <CardInformation
                        title="تاریخ ایجاد"
                        value={toJalaliDate(
                            smsCampaign.createDate,
                            "YYYY/M/D HH:mm"
                        )}
                    />
                    {smsCampaign.scheduleDate && (
                        <CardInformation
                            title="تاریخ ارسال"
                            value={toJalaliDate(
                                smsCampaign.scheduleDate,
                                "YYYY/M/D HH:mm"
                            )}
                        />
                    )}
                    <CardInformation
                        title="تعداد پیامک"
                        value={smsCampaign.totalSmsCount}
                    />
                    <CardInformation
                        title="تعداد پارت"
                        value={smsCampaign.totalPartCount}
                    />
                    <CardInformation
                        title="تعداد پارت بازگشتی"
                        value={smsCampaign.refundedPartCount ?? "-"}
                    />
                </Stack>

                <Divider />

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Button
                        onClick={openRecordsDialog}
                        size="small"
                        variant="contained"
                    >
                        جزییات ارسال
                    </Button>

                    <Chip
                        sx={{ bgcolor: smsCampaignStatus.color }}
                        size="small"
                        label={
                            <Typography color="white">
                                {smsCampaignStatus.text}
                            </Typography>
                        }
                    />
                </Stack>
            </Stack>
        </Card>
    );
}
